import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { MoneyTextBoxEditor } from "../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { InvestmentsAction } from "../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { ChargesHelper } from "../../Common/Helpers/ChargesHelper";

interface IAddOneOffWithdrawalProps extends IProcessComponentProps {
    data: IsaContributionModel | GiaContributionModel | PensionContributionModel;
    type: SubAccountType;
    extraInfo: WhatIfToolDetailModel;
}

interface IAddOneOffWithdrawalState {}

export class AddOneOffWithdrawal extends ProcessComponent<IAddOneOffWithdrawalProps, IAddOneOffWithdrawalState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private calculateMaxSingleWithdrawal(): number {
        const currentTotal = InvestmentsAction.getInvestmentData(this.props.extraInfo?.CurrentHoldings)?.total
            ?.MarketValue?.Amount;
        const previousAmount = ChargesHelper.getTotalForIACEstimation(this.props.data?.Contribution, this.props.type);
        return (currentTotal || 0) + (previousAmount || 0);
    }

    public render(): JSX.Element {
        const { type, data, onChange } = this.props;
        return (
            <>
                <Alert
                    alertType={AlertType.Warning}
                    message="For the purposes of this What If illustration, the maximum estimated withdrawal includes any single payments and transfers. Withdrawals are assumed to be taken proportionally."
                />
                <Typography
                    type="vertical"
                    wrapCss="mt-20"
                    config={[
                        {
                            title: "Maximum estimated single withdrawal",
                            data: MoneyDisplayHelper.getMoneyFormat({
                                Amount: this.calculateMaxSingleWithdrawal(),
                                Currency: CurrencyCode.GBP,
                            }),
                        },
                    ]}
                />
                <MoneyTextBoxEditor
                    label="Withdrawal value"
                    currency={CurrencyCode.GBP}
                    value={data?.Contribution?.OneOffWithdrawal?.Amount?.Amount}
                    onChange={(v) =>
                        this.onDataChange(
                            onChange,
                            {
                                OneOffWithdrawal: {
                                    ...data?.Contribution?.OneOffWithdrawal,
                                    Amount: { Amount: v, CurrencyCode: CurrencyCode.GBP },
                                },
                            },
                            data,
                            "Contribution"
                        )
                    }
                    cssWrapper={"control-size-430"}
                    atMost={{
                        value: this.calculateMaxSingleWithdrawal(),
                        errorMessage: "Cannot be larger than maximum single withdrawal value",
                    }}
                />
            </>
        );
    }
}
